var metricTypes;

metricTypes = require('../../modules/shared/presenters/interaction-goals-success-metric-types');

$(function() {
  var addBHEventHandler;
  addBHEventHandler = function(bloodhound) {
    var bh;
    if (bloodhound) {
      Object.defineProperty(OptimizeSuite, 'bloodhound', {
        configurable: true,
        writable: true,
        value: bloodhound
      });
    }
    bh = OptimizeSuite.bloodhound;
    return bh.on('event', function(bhEvent) {
      var affiliateUrl, clickToUrl, clickedOn, closestLink, directLink, joint, modalUrl;
      if (bhEvent.type === 'click') {
        clickedOn = $(bhEvent.jQueryEvent.target);
        if ((clickedOn.hasClass('affiliate-url')) || (clickedOn.hasClass('affiliate-direct'))) {
          try {
            window.OptimizeSuite.InteractionGoals.successMetric({
              type: metricTypes.COUPONS_CLICK_ALL,
              channel: 'coupons'
            });
          } catch (error) {}
          if ($('body').hasClass('is-touch-request')) {
            try {
              window.OptimizeSuite.InteractionGoals.successMetric({
                type: metricTypes.COUPONS_CLICK_TOUCH_ALL,
                channel: 'coupons'
              });
            } catch (error) {}
          }
        }
        if (clickedOn.hasClass('affiliate-url')) {
          bhEvent.jQueryEvent.preventDefault();
          closestLink = clickedOn.closest('.coupon');
          modalUrl = "//" + location.host + location.pathname + "?c=" + (closestLink.attr('data-uuid'));
          if (clickedOn.hasClass('alternate-button')) {
            modalUrl += "&alt=1";
          }
          affiliateUrl = closestLink.attr('data-network-name') === 'Groupon' && closestLink.attr('data-merchant').indexOf('Groupon') === -1 ? (closestLink.attr('data-merchantaffiliateurl')) + "?eid=" + bhEvent.id : (closestLink.attr('data-affiliateurl')) + "?eid=" + bhEvent.id;
          Coupons.popAffiliateLink(modalUrl, affiliateUrl);
          false;
        }
        if (clickedOn.hasClass('affiliate-direct')) {
          bhEvent.jQueryEvent.preventDefault();
          closestLink = clickedOn.closest('.affiliate-direct');
          directLink = closestLink.attr('href') || closestLink.attr('data-affiliateurl');
          joint = directLink.indexOf('?') === -1 ? '?' : '&';
          clickToUrl = "" + directLink + joint + "eid=" + bhEvent.id;
          window.open(clickToUrl, '_blank');
          return false;
        }
      } else {
        return true;
      }
    });
  };
  if (OptimizeSuite.bloodhound) {
    return addBHEventHandler();
  } else {
    return Object.defineProperty(Optimize, 'bloodhound', {
      configurable: true,
      set: addBHEventHandler
    });
  }
});

